import styled from "styled-components";

import { Text } from "@ui/Atoms";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_16};
  width: 100%;
`;

export const Title = styled(Text).attrs({
  $style: "regular_12",
  $color: "grey100",
})``;
